<template>
  <div class="container-fluid">
    <div v-cloak class="animated fadeIn">
      <h1 class="mb-4">WhiteList TED</h1>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <div class="d-flex align-items-center justify-content-between">
                <div
                  class="row justify-content-between align-items-center"
                  style="min-width: 20%"
                >
                  WhiteList TED Candidates
                </div>
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    gap-2
                  "
                >
                  <input
                    type="text"
                    class="form-control"
                    id="entity"
                    v-model="entity"
                    placeholder="Name of entity"
                  />
                  <input
                    type="text"
                    class="form-control"
                    id="counter"
                    v-model="counter"
                    placeholder="Name of Counterpart"
                  />
                  <button
                    @click="() => search()"
                    class="btn btn-outline-dark v2-mz-btn"
                    type="button"
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        no-wrap
                      "
                    >
                      <i class="fa fa-search pr-1"></i>
                      Search
                    </div>
                  </button>
                  <button
                    @click="confirmWhitelist"
                    class="btn btn-outline-primary"
                    type="button"
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        no-wrap
                      "
                    >
                      <i class="fa fa-external-link pr-1"></i>
                      Confirm WhiteListing
                    </div>
                  </button>
                </div>
              </div>
              <hr />
            </div>
            <div class="card-body" v-if="isLoading">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div class="card-body" v-if="searchResults.length">
              <table-component
                :columns="columns"
                :data="tableData"
                :filter-exclude-columns="filterExcludeColumns"
              >
                <template slot="Merge" slot-scope="{ row }">
                  <input
                    v-model="checkedRows"
                    type="checkbox"
                    :value="row.ted_id"
                  />
                </template>

                <template slot="score" slot-scope="{ row }">
                  <div>
                    {{ row.score ? row.score.toFixed(2) : "" }}
                  </div>
                </template>

                <template slot="postal_score" slot-scope="{ row }">
                  <div>
                    {{ row.postal_score ? row.postal_score.toFixed(2) : "" }}
                  </div>
                </template>

                <template slot="name_score" slot-scope="{ row }">
                  <div>
                    {{ row.name_score ? row.name_score.toFixed(2) : "" }}
                  </div>
                </template>

                <template slot="street_score" slot-scope="{ row }">
                  <div>
                    {{ row.street_score ? row.street_score.toFixed(2) : "" }}
                  </div>
                </template>
              </table-component>
            </div>
            <div class="card-body" v-else-if="hasResult">
              <a> No result found </a>
            </div>
            <div class="card-body" v-else>
              <a> Please enter a valid name </a>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header bg-transparent">
          Whitelist Manually Process
          <hr />
        </div>
        <div class="card-body" v-if="isLoading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="card-body" v-if="searchResultsm.length">
          <table-component
            :columns="columnsm"
            :data="tableDatam"
            :filter-exclude-columns="filterExcludeColumns"
          >
            <template slot="Merge" slot-scope="{ row }">
              <input v-model="checkedRowsm" type="checkbox" :value="row.id" />
            </template>
          </table-component>
        </div>
        <div class="card-body" v-else-if="hasResult">
          <a> No result found </a>
        </div>
        <div class="card-body" v-else>
          <a> Please enter a valid name </a>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header bg-transparent">
        WhiteList File
        <hr />
      </div>
      <div class="card-body">
        <span class="float-left">
          <button
            @click="
              $downloadFile({
                name: `whitelist.xlsx`,
                fileId: 77,
                url: `${BASE_URL}api/files/download/`,
              })
            "
            class="btn btn-outline-primary"
          >
            <i class="fa fa-download pr-1"></i>
            Download white list file
          </button>
        </span>
        <span class="float-right">
          <file-dragdrop
            title="Select a document file to upload"
            label="Upload"
            @upload="
              (files) =>
                $uploadFile({
                  fileId: 5,
                  file: files[0],
                  fileName: `white_list.xlsx`,
                })
            "
          >
          </file-dragdrop>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";
import { ActiveUser } from "@/services/user";

export default {
  name: "Whitelist",
  data() {
    return {
      BASE_URL,
      apiEndpointBase: `${BASE_URL}api/whitelist`,
      columns: [
        "counterpart_id",
        "counterpart_country_code",
        "entity_country_code",
        "counterpart_name",
        "entity_name",
        "counterpart_street_address",
        "entity_street_address",
        "counterpart_postal_address",
        "entity_postal_address",
        "score",
        "name_score",
        "street_score",
        "postal_score",
        "Merge",
      ],
      columnsm: [
        "counterpart_id",
        "counterpart_country_code",
        "entity_country_code",
        "counterpart_name",
        "entity_name",
        "counterpart_street_address",
        "entity_street_address",
        "counterpart_postal_address",
        "entity_postal_address",
        "Merge",
      ],
      tableData: null,
      tableDatam: null,
      hasResult: false,
      searchResults: [],
      searchResultsm: [],
      isLoading: false,
      entity: "",
      counter: "",
      checkedRows: [],
      checkedRowsm: [],
      checked: { selected: [] },
    };
  },
  methods: {
    async search() {
      this.isLoading = true;
      let requestUrl = `${this.apiEndpointBase}/search/both/${this.counter}/${this.entity}`;
      let secondRequestUrl = null;
      if (this.entity.length === 0 && this.counter.length === 0) {
        requestUrl = this.apiEndpointBase;
      } else if (this.counter.length === 0) {
        requestUrl = `${this.apiEndpointBase}/search/entity_name/${this.entity}`;
      } else if (this.entity.length === 0) {
        requestUrl = `${this.apiEndpointBase}/search/counterpart_name/${this.counter}`;
      } else {
        secondRequestUrl = `${this.apiEndpointBase}/search/manual/${this.counter}/${this.entity}`;
      }

      const {data} = await this.$request({url: requestUrl});
      this.tableData = data;
      this.searchResults = data;
      if (secondRequestUrl) {
        const datam = (await this.$request({url: requestUrl})).data;
        this.tableDatam = datam;
        this.searchResultsm = datam;
      }
      this.hasResult = true;
      this.isLoading = false;
    },
    async confirmWhitelist() {
      if (this.checkedRows.length === 0 && this.checkedRowsm.length === 0) {
        alert("Please Select Rows");
        return;
      }
      const email = ActiveUser.get().email;
      const { res } = await this.$request({
        url: `${this.apiEndpointBase}/send`,
        method: "POST",
        body: {
          selection: this.checkedRows,
          selectionm: this.checkedRowsm,
          manual: this.searchResultsm,
          email: email,
          counterpart: this.counter,
          entity: this.entity,
        },
      });
      if (res.status === 200 || res.status === 201) {
        alert("Added to Whitelist");
        this.checkedRows = [];
        this.checkedRowsm = [];
        this.search()
      } else {
        alert("Something went wrong");
      }
    },
  },
};
</script>

<style scoped></style>
